import { createTheme } from '@mui/material/styles';
import hexToRgba from 'hex-to-rgba';
import { RGB_Log_Shade } from 'utils/utils';

/**
 * Creates a Material-UI theme based on primary and secondary colors
 *
 * @param {string} mainColor - The primary color in hex format (e.g., '#6699cc')
 * @param {string} secondaryColor - The secondary color in hex format (e.g., '#203b0e')
 * @returns {Theme} Material-UI theme object
 *
 * Features:
 * - Custom color palette with opaque variants
 * - Styled tooltips with inverted colors and shading
 * - Custom input base styling with disabled state
 */
export function createAppTheme(mainColor, secondaryColor) {
	// Create opaque variants of the colors for transparency effects
	const mainOpaqueColor = hexToRgba(mainColor, 0.5);
	const secondaryOpaqueColor = hexToRgba(secondaryColor, 0.5);

	return createTheme({
		spacing: 8,
		palette: {
			primary: {
				main: mainColor,
				mainOpaque: mainOpaqueColor,
			},
			secondary: {
				main: secondaryColor,
				mainOpaque: secondaryOpaqueColor,
			},
		},
		components: {
			// Custom tooltip styling with color shading
			MuiTooltip: {
				styleOverrides: {
					tooltip: {
						fontSize: '0.8em',
						color: RGB_Log_Shade(-0.7, hexToRgba(mainColor)),
						backgroundColor: RGB_Log_Shade(0.7, hexToRgba(secondaryColor)),
					},
				},
			},
			// Custom input base styling
			MuiInputBase: {
				styleOverrides: {
					root: {
						backgroundColor: 'white',
						'&.Mui-disabled': {
							backgroundColor: '#f5f5f5',
						},
					},
				},
			},
		},
	});
}
